import { render, staticRenderFns } from "./LMSCourse.vue?vue&type=template&id=cf3d8780&"
import script from "./LMSCourse.vue?vue&type=script&lang=js&"
export * from "./LMSCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports